"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleDynamoMapper = void 0;
const dynamodb_mapper_1 = require("../dynamodb-mapper");
const module_json_1 = require("./module-json");
exports.ModuleDynamoMapper = (0, dynamodb_mapper_1.createDynamoMapper)('Module', module_json_1.ModuleJsonMapper);
